<template lang="pug">
AppPopover(
  ref="AppPopover"
  extra-popover-classes="vue-time-entries-edit-time-span-popover"
  lazy
  popover-container-classes=""
  @hide="close"
  @show="open"
)
  template(#body)
    TimeEntriesFormPopoverForm(
      :time-entry="timeEntry"
      :time-entries="timeEntries"
      :type="type"
      :show="show"
      @close="close"
      @replace-time-entry="replaceTimeEntry"
      @open-edit-dialog="openEditDialog"
    )
  template(#trigger)
    slot
</template>

<script>
export default {
  name: 'TimeEntriesFormPopover',
  props: {
    timeEntry: {
      type: Object,
      required: true,
    },
    timeEntries: {
      type: Array,
      default: () => [],
      required: false,
    },
    type: {
      type: String,
      default: 'edit',
      required: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    close() {
      this.show = false;
      this.$refs.AppPopover.close();
    },
    open() {
      this.show = true;
    },
    replaceTimeEntry(timeEntry) {
      this.$emit('replace-time-entry', timeEntry);
    },
    openEditDialog(showDialog) {
      this.$emit('open-edit-dialog', showDialog);
    },
  },
};
</script>
